import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SecurityContext,
  signal,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IBusinessClassificationSelectorNaicsGroupHeaderComponent } from '@boldpenguin/sdk';

@Component({
  selector:
    'emperor-bp-sdk-business-classification-selector-naics-group-header',
  templateUrl:
    './bp-sdk-business-classification-selector-naics-group-header.component.html',
  styleUrls: [
    './bp-sdk-business-classification-selector-naics-group-header.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BpSdkBusinessClassificationSelectorNaicsGroupHeaderComponent
  implements
    IBusinessClassificationSelectorNaicsGroupHeaderComponent,
    OnChanges
{
  /**
   * NAICS code
   */
  @Input() naicsCode: string;
  /**
   * NAICS industry description
   */
  @Input() naicsDescription: string;
  /**
   * NAICS explanation for popover
   */
  @Input() naicsExplanation: string;

  explanation;
  readonly panelOpenState = signal(false);

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.naicsExplanation) {
      this.explanation =
        this.sanitizer.sanitize(SecurityContext.HTML, this.naicsExplanation) ??
        '';
    }
  }
}
